import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { HiCheckCircle } from 'react-icons/hi';
import Logo from '../common/Logo';
import {
  $white,
  $primaryFont,
  $medium,
  $gray,
  $black,
  $steelBlue,
  $gold,
} from '../../styles';

const BackButton = styled.div`
  font-family: ${$primaryFont};
  display: inline-flex;
  align-items: center;
  line-height: 1rem;
  font-weight: ${$medium};
  cursor: pointer;
  color: ${$black};
  height: 2.5rem;
  padding-right: 1rem;
  span {
    margin-bottom: 3px;
  }
  position: absolute;
  z-index: 4;
`;

const LeftArrow = styled(MdKeyboardArrowLeft)`
  font-size: 1.5rem;
  margin-right: 0.25rem;
`;

export const Back = () => {
  const history = useHistory();
  return (
    <BackButton onClick={() => history.goBack()}>
      <LeftArrow />
      <span>Back</span>
    </BackButton>
  );
};

export const AbsolutePositionedLogo = styled(Logo)`
  position: absolute;
`;

export const Container = styled.div`
  height: 100%;
  min-height: 50rem;
  display: none;
  @media screen and (min-width: 860px) {
    display: flex;
  }
`;

export const ContentPane = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;
  background: transparent;
  padding: 4rem 2rem;
  flex: 1 1 31rem;
  @media screen and (min-width: 996px) {
    padding: 4rem;
    flex: 1 1 36rem;
  }
`;

export const CenterContainer = styled.div`
  margin: auto;
`;

export const FormPane = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;
  background: ${$white};
  padding: 4rem 2rem;
  flex: 1 1 31rem;
  @media screen and (min-width: 996px) {
    padding: 4rem;
    flex: 1 3 54rem;
  }
`;

export const Divider = styled.hr`
  margin: 2rem 0;
  color: ${$gray};
`;

export const InputContainer = styled.div`
  display: flex;
  margin: -1rem -0.25rem;
`;

export const ButtonContainer = styled.div`
  margin-top: 1.5rem;
`;

export const AuthEscape = styled.div`
  font-size: 1rem;
  color: ${$steelBlue};
  font-family: ${$primaryFont};
  margin-bottom: 0.5rem;
  text-align: ${({ position }) => position || 'left'};
  a {
    color: ${$gold};
    text-decoration: underline;
  }
`;

export const AuthForm = styled.form`
  max-width: unset;
  @media screen and (min-width: 576px) and (max-width: 859px) {
    max-width: 60%;
    margin: 2rem auto 0 auto;
  }
`;

export const AuthConfirmation = styled.div`
  margin: 2rem auto 0 auto;
  @media screen and (min-width: 576px) and (max-width: 859px) {
    max-width: 60%;
  }
`;

export const MobileFormCard = styled.div`
  padding: 2rem;
  border-radius: 2rem 2rem 0 0;
  background: ${$white};
  ${({ fullSize }) => fullSize && `
    border-radius: 0;
    text-align: center;
  `}
`;

export const MobileContainer = styled.div`
  display: block;
  @media screen and (min-width: 860px) {
    display: none;
  }
`;

export const MobileFormPane = styled.div`
  background: ${$black};
`;

export const MobileFormContent = styled.div`
  padding: 1.5rem;
  @media screen and (min-width: 576px) {
    max-width: 55%;
    margin: auto;
    text-align: center;
    ${AuthEscape} {
      text-align: center;
    }
  }
`;

export const MobileFormCopy = styled.div`
  margin: 2rem 0 1rem 0;
`;

export const DesktopFormContainer = styled.div`
  margin: -3.5rem auto 0 auto;
  align-self: center;
  max-width: 27rem;
  margin-top: -3.5rem;
  display: none;
  @media screen and (min-width: 860px) {
    display: block;
  }
`;

export const Icon = styled.img`
  margin-bottom: 1rem;
  width: 5rem;
  @media screen and (min-width: 576px) {
    width: 6rem;
    margin-bottom: 1.5rem;
  }
  @media screen and (min-width: 860px) {
    width: 7rem;
    margin-bottom: 2rem;
  }
`;

export const VerifiedIcon = styled(HiCheckCircle)`
  height: 5rem;
  width: 5rem;
  margin-bottom: 1rem;
  @media screen and (min-width: 860px) {
    height: 6rem;
    width: 6rem;
    margin-left: -0.5rem;
  }
  color: ${$gold};
`;
